export const phoneNumberRegExp = /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/;
export const zipCodeRegExp = /^[0-9]{5}$/;
